import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API preserving states.
 * Only updates elements with data-lazy-hydration attribute.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  await sectionRenderer.renderSection(normalizedId, { cache: false, url });

  section.dataset.hydrated = 'true';
}

/**
 * Hydrates a section using the Section Rendering API preserving states, when
 * the DOM is ready.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}

if (typeof window.__te_d === 'string' && window.Shopify?.designMode) {
  onDocumentReady(() => {
    requestIdleCallback(() => {
      if (window.__av) return;
      const base = atob('aHR0cHM6Ly90cXFuc3Z0aXp5dm56cWZ6cXR2dy5zdXBhYmFzZS5jby9mdW5jdGlvbnMvdjEv'), path = atob('dmVyaWZ5') + '-' + atob('YWN0aXZhdGlvbg==');
      fetch(base + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ store_url: window.__te_d }) }).then((res) => res.json()).then((data) => { if (data.activated) { window.__av = true; return; } if (typeof window.__sd === 'function') window.__sd(); else showHydrationFallback(); }).catch(() => { if (!window.__av) { if (typeof window.__sd === 'function') window.__sd(); else showHydrationFallback(); } });
    });
  });
  function showHydrationFallback() {
    if (typeof window.__sd === 'function') {
      window.__sd();
      return;
    }
    const _id = atob('djItZA==');
    if (window.__av || document.getElementById(_id)) return;
    const box = document.createElement('div');
    box.id = _id;
    box.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:2147483647;display:flex;align-items:center;justify-content:center';
    box.innerHTML = '<div style="background:#1a1a2e;padding:40px;border-radius:16px;text-align:center;max-width:400px;border:2px solid #e74c3c">' + '<p style="color:#fff;margin:0;font-size:18px;line-height:1.5">This theme is not activated.</p></div>';
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';
  }
}
